const defaultParams ={
    //label
    label :'',
    //类型 text,select,date,textarea
    comType :'text',
    //prop
    prop :'',
    //comType==select 对应list的名称
    listName :'',
    //图标名
    icon :'',
    //格式化方法 value 当前值,prop 当前prop,fillData 数据
    format :(value,prop,fillData)=>null,
    //必填 true
    required :true,
    //验证pattern 正则
    pattern :null,
    //错误信息
    errMsg :null,
    //描述信息
    description :null,
    //最大长度
    maxlength :null,
    //placeholder
    placeholder:null,
    //labelWidth number
    labelWidth:null,
    //可编辑
    edit:false,
    //隐藏
    hidden:false,

}
export class ListItem{
    constructor(params=defaultParams) {
        //label
        this.label = params.label;
        //类型 text,select,date,
        this.comType = params.comType||'text';
        //prop
        this.prop = params.prop;
        //comType==select 对应list的名称
        this.listName = params.listName;
        //图标名
        this.icon = params.icon;
        //格式化方法
        this.format = params.format;
        //必填 true
        this.required = params.required;
        //验证pattern 正则
        this.pattern = params.pattern;
        //错误信息
        this.errMsg = params.errMsg||(this.label+(['select','date'].includes(this.comType)?'未选择':'未填写'));
        //描述信息
        this.description = params.description;
        //最大长度
        this.maxlength = params.maxlength;
        this.labelWidth = params.labelWidth;
        this.edit = params.edit;
        this.hidden = params.hidden;

        this.placeholder=params.placeholder||(['select','date'].includes(this.comType)?'请选择':'请输入')+this.label

    }
}